import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/locations", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/locations/csv", params);
};

const get = id => {
  return restApi.get(`/api/locations/${id}`);
};

const upsert = data => {
  return restApi.post("/api/locations/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/locations/${ids}`);
};

const getLookup = (params) => {
  return restApi.get("/api/locations/lookup", { params });
}

const locationService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove,
  getLookup
};

export default locationService;